<template>
    <div class=" logologin">
        <router-link to="/">
          <v-img :src="logo" class="homeLogo" max-width="180"  max-height="76"></v-img>
        </router-link>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState('siteconfig', ['config']),
    logo: function () {
      return this.config ? require(`@/assets/img/${this.config.imgFolder}/${process.env.VUE_APP_NODE_ENV_API}/Logo.svg`) : ''
    }
  }
}
</script>
